export { default } from './ValuePropositionList';
